import React, { Component } from 'react';
import Comment from '../../../../common/comments/comment.component';
import { MAX_LENGTH } from '../../../../../constants/external-constants';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { planCatalogueActions } from '../../../../../store/external/finance/plan-catalogue.reducer';
import { Loading } from '../../../../common/loading';

class PlanCatalogueComment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount() {
        const { getPlanCatalogueComments} = this.props;
        getPlanCatalogueComments(this.props.planId, 1, 5, false)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

     postComment = async (attachedFilename, attachedFileData, commentDescription) => {
       const { postPlanCatalogueComments } = this.props;
       await postPlanCatalogueComments(this.props.planId, attachedFilename, attachedFileData, commentDescription);
    }

    handleDeleteCatalogueComments = async (planId) => {
        this.setState({ isLoading: true });
        const { deletePlanCatalogueComments, getPlanCatalogueComments, resetPlanCatalogueComments } = this.props;

        await deletePlanCatalogueComments(planId, this.props.planId);
        await resetPlanCatalogueComments();
        await getPlanCatalogueComments(this.props.planId).then(() => {
            this.setState({ isLoading: false })
        });
        this.setState({ show: false })
    }

    handleLoadMore = async () =>{
        const {getPlanCatalogueComments, planCatalogue } = this.props;
        await getPlanCatalogueComments(this.props.planId, planCatalogue.pageIndex + 1)
    }

    componentWillUnmount(){
        const { resetPlanCatalogueComments } = this.props;
        resetPlanCatalogueComments();
    }

    render() {

        if (this.state.isLoading) {
            return <Loading />
        }

        const { planCatalogueComments } = this.props.planCatalogue;
 
        return (
            <div>
                <Comment
                    commentList={planCatalogueComments}
                    addCommentAction={this.postComment}
                    deleteCommentAction={this.handleDeleteCatalogueComments}
                    maxLength={MAX_LENGTH.limit_500}
                    isPlanCatalogueComment={true}
                    handleLoadMore={this.handleLoadMore}
                    hasMoreComments={this.props?.planCatalogue?.hasMoreComments}
                    //Access Type
                    isReadOnly={this.props.isReadOnly}
                    isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                    isReadAndWrite={this.props.isReadAndWrite}
                />
            </div>
        );
    }
}



export default connect(
    state => {
        const { planCatalogue } = state;

        return {
            planCatalogue
        }
    },
    dispatch => bindActionCreators(
        Object.assign({}, planCatalogueActions),
        dispatch
    )
)(PlanCatalogueComment);